module.exports = __webpack_public_path__ + "img/電気回路_2_5_4.9c28571d.png";